module.exports = __webpack_public_path__ + "img/marketsonics.5686633f.svg";